import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LayoutPro from "./layoutPro";
import { create, get } from "../../services/services";
import PlanCard from "./planCard";

function ChoiceFormula() {
  const navigate=useNavigate()
  const [plans,setPlans]=useState([])
 
  useEffect(()=>{
    get('subscriptions')
    .then((res)=>{
      // console.log(res)
      setPlans(res?.data)
    })
    .catch((err)=> {
      // console.log(err)
    })
  },[])
  return (
    
       <LayoutPro
            currentStep={2}
            btn={false}
            // nextStep={"/billingaddress"}
            // handleSubmit={handleSubmit}
            // nameBtnSubmit="Étape suivante"
          //  disabled={isSubmitting}
          >
      <div className="cader-page">
       
        <div className="container"> 
          <h3 className="grey500">Choix de la formule</h3>
          <div className="row mt-40">
          <div className="col-md-3 padding-8 d-flex">
              <div className="card-border">
                <div className="card-padding">
                  <h4 className="card-title mb-24">Plan liberté</h4>
                  <h2 className="card-price">0€</h2>
                  <p className="col card-text">
                    Seulement 3% de commission par rendez-vous
                  </p>
                  <div className="d-flex mt-24">
                    <img src="/images/check-01.svg" alt="check icon" />{" "}
                    <span className="text-body-card">Sans engagement</span>
                  </div>
                  <div className="d-flex">
                    <img src="/images/check-01.svg" alt="check icon" />{" "}
                    <span className="text-body-card">Accès illimité</span>
                  </div>
                  <div className="d-flex">
                    <img src="/images/check-01.svg" alt="check icon" />{" "}
                    <span className="text-body-card">
                      Frais de gestion compris
                    </span>
                  </div>
                </div>
                <button
                  type="button"
                  className="twyny-cta-secondary card-button"
                  onClick={()=>{navigate(`/billingaddress`,{state:{plan:"libre"}})}}
                >
                  Commencer gratuitement
                </button>
              </div>
            </div>
            {plans.map((plan)=>{
              return(
                <PlanCard plan={plan} />
              )
            })}
         
          </div>
        </div>
        <div className="h130"></div>
      </div>
      </LayoutPro >

  );
}

export default ChoiceFormula;
